import { render } from "./myPeriodicidade.vue?vue&type=template&id=3f4648d8"
import script from "./myPeriodicidade.vue?vue&type=script&lang=js"
export * from "./myPeriodicidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__